import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { EXAM_TYPES } from "app/types/examTypes";

const ExamImpSeries = Loadable(lazy(() => import("./ExamImpSeries")));

const routes = Object.values(EXAM_TYPES).map(examType => ({
  path: `${examType.pathPrefix}/exam-imp-series`,
  element: <ExamImpSeries />
}));

export default routes;
